import { requestSuggest } from '../../dataSource/suggest/suggest.requests'
import SuggestError from '../../domain/suggest/SuggestError'
import { selectLocale } from '../locale/locale.selectors'
import { selectMapBbox } from '../map/map.selectors'
import {
  LOAD_SUGGEST_ERROR,
  LOAD_SUGGEST_RESPONSE,
  RESET_SUGGEST_DATA,
  SET_SUGGEST_INPUT_VALUE
} from './suggest.actionTypes'
import parse from './suggest.dataParser'

function isResponseFromLastRequest(suggest, requestTime) {
  return suggest.lastRequestTime < requestTime
}

export const setSuggestInputValue = value => dispatch => {
  dispatch({
    type: SET_SUGGEST_INPUT_VALUE,
    payload: value
  })
}

export const resetSuggestData = () => (dispatch, getState) => {
  dispatch({
    type: RESET_SUGGEST_DATA
  })
}

export const suggest =
  ({ terms, suggestFilterType = 'all' }) =>
  (dispatch, getState) => {
    if (!terms) {
      resetSuggestData()(dispatch, getState)
      return Promise.resolve()
    }

    setSuggestInputValue(terms)(dispatch, getState)

    const requestTime = Date.now()
    const locale = selectLocale(getState())
    const bbox = selectMapBbox(getState())
    return requestSuggest(bbox, locale, { terms, suggestFilterType })
      .then(response => {
        const { data } = response

        if (!data?.suggests) {
          throw new SuggestError()
        }

        const parsedData = parse(data)
        const { suggest } = getState()

        if (isResponseFromLastRequest(suggest, requestTime)) {
          dispatch({
            type: LOAD_SUGGEST_RESPONSE,
            payload: { data: parsedData, requestTime }
          })
        }
      })
      .catch(error => {
        const { suggest } = getState()
        if (isResponseFromLastRequest(suggest, requestTime)) {
          dispatch({
            type: LOAD_SUGGEST_ERROR,
            payload: { error, requestTime }
          })
        }
      })
  }
